import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2jmpkerms: FaireProductEntity = {
  token: "p_n2jmpkerms",
  type: "product",
  name: "Blonde Hinoki– HI-FI Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/c111964112c975eb48cfa308f8ec634b6a9946f4fd56ff4edc857e5e4107cbdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24964e732f3cb04f312565b582ef76bb6f25199e6907ec7e74b97a40ad4a75e6.jpeg",
    "https://cdn.faire.com/fastly/07216b13cee9b95b91f59944b492f5c8fed3bf5e34d0598883d2095f20e3be35.jpeg",
    "https://cdn.faire.com/fastly/ec40e4ba6752d2f66cbd4a4d1ea2f59941c610694b461fbabded9965440ac9cb.jpeg",
    "https://cdn.faire.com/fastly/773820db2dcbc23c05e1b76ba2b451ae8c75036f0b2d1c260db6045a30544923.jpeg",
    "https://cdn.faire.com/fastly/4360c47c9a100dc14def27d13cb1bb6b47f16e2df06b90b3d1ae16730de62f71.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "Inspired by the light woods used to house records in a hi-fi listening bar. Clean and warm, uplifted by aromatic greenery and eucalyptus.  Golden cypress, green petitgrain, and elemi resin.\n\nPRODUCT INFORMATION: \n\nOur 13 oz Double Wick Hi-Fi Candles are hand-poured into premium cocoa brown vessels with a vermilion debossed label, and packaged in a premium paper gift box.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for up to 60 hours.",
  tags: [],
  msrpDollars: 43.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:03.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
